import { ChargePoint } from '../common/redux/api/web-api'
import { hasFeature } from '../common/services/ocppService'

import isDawn from './isDawn'
import isLuna from './isLuna'

export default function doesSupportSmartSchedule(chargePoint?: ChargePoint): boolean {
    if (!chargePoint) return false
    if (chargePoint.productType === 'Aura' && chargePoint.installedFirmwareVersion >= 110) return true
    if (chargePoint.productType === 'Halo2' && chargePoint.installedFirmwareVersion >= 130) return true
    if ((isDawn(chargePoint) || isLuna(chargePoint)) && hasFeature('SmartCharging', chargePoint?.ocppConfigKeys))
        return true
    return false
}
